/* file description */

import { Api } from '@cui/req';


// 查询模板接口
const findTempleteInfo = async (task_id: string) => {
  const [err, res] = await Api({
    url: `/api/gateway/metabase/compose/task/template/${task_id}`,
    method: 'get',
  });
  return res?.data;
};
// 查询数据资产接口接口
export async function getTaskPropertySettings(
  taskId: string,
  idList: string[],
): Promise<any> {
  const [err, res] = await Api({
    method: 'post',
    url: '/api/gateway/metabase/api/v1/tech/scene_activity_task_logic_entity_property/page',
    data: {
      condition: 'logic_entity_id in( ${idList}) and task_id=${taskId} ',
      fetchChildren: false,
      idToName: false,
      pageNum: 1,
      pageSize: 1000,
      parameters: {
        idList,
        taskId,
      },
      select: '',
      sort: '',
    },
  });
  return res?.data?.data || {};
}


export enum PageType {
  Create = 'create',
  Edit = 'edit',
  Detail = 'detail',
  List = 'list',
}

interface PageInitializationType {
  taskId: string;
  pageType: PageType;
  taskTemplateInterface?: any;
  taskFieldInterface?: any;
}


export class PageInitialization {
  /**
   *  融合任务后的moduleList
   */
  moduleList: Array<Record<string, any>>;
  /**
   * 任务ID taskId
   */
  taskId: string;
  /**
   * 生成页面的初始画配置
   */
  config: Record<string, any>;
  /**
   * 当前页面的类型
   */
  pageType: PageType;
  /**
   * 获取任务下的模板接口，没有会触发请求
   */
  taskTemplateInterface: any;
  /**
   *  获取任务下配置的属性接口， 没有会触发请求
   */
  taskFieldInterface: any;

  /**
   * 初始化
   */
  constructor({
    taskId,
    pageType,
    taskTemplateInterface,
    taskFieldInterface,
  }: PageInitializationType) {
    this.moduleList = [];
    this.config = {
      freeBtnConfig: [],
      pageModuleConfig: {},
      freedomComponents: [],
      rulePageValue: [],
      topTableBtnConfig: [],
    };
    this.taskId = taskId;
    this.pageType = pageType;
    this.taskTemplateInterface = taskTemplateInterface;
    this.taskFieldInterface = taskFieldInterface;
  }

  /**
   * 根据页面类型触发config
   */
  async initConfig() {
    await this.createModuleList(this.taskId);
    this.initPageModuleConfig();
    return this.config;
  }

  /**
   * 生成模型的配置函数
   */
  async createModuleList(taskId: string) {
    const taskTem = this.taskTemplateInterface || await findTempleteInfo(taskId);
    const moduleIdList = taskTem?.modules.map((item: any) => (item.moduleID));
    // 获取任务下的属性
    const resultTaskFields = this.taskFieldInterface || await getTaskPropertySettings(taskId, moduleIdList);
    for (const module of taskTem?.modules) {
      const resList = resultTaskFields?.filter((item: any) => item.logic_entity_id === module.moduleID) || [];
      if (taskTem.mainModuleId === module.moduleID) {
        module.mainModule = true;
      }
      module.fields = resList.map((resLi: any) => {
        if (resLi.field_id == module.fields.find((re: any) => re.fieldID == resLi.field_id)?.fieldID) {
          return module.fields.find((re: any) => re.fieldID == resLi.field_id);
        }
      }).filter((item: any) => item !== undefined);
    }
    this.moduleList = taskTem?.modules;
  }

  initPageModuleConfig() {
    // 初始化pageConfig
    const moduleConfig: Record<string, any> = {};
    this.moduleList.forEach((module: any, index: number) => {
      // 生成默认配置
      moduleConfig[module.handle] = {
        sequence: index,
        isUseGroup: false, // 是否开启编排分组
        isFileModule: false, // 是否为上传模型
        tabShow: true, // 是否隐藏模型
        tabName: '', // 重定向模型名称
        groupTitle: [], // 分组名称
        groupField: [module?.fields?.map((item: any) => {
          return {
            fieldID: item.fieldID,
            label: item.label,
            name: item.name,
          };
        })], // 初始化分组
        configList: module?.fields?.map((item: any) => {
          return {
            moduleName: module.handle,
            fieldID: item.fieldID,
            label: item.label,
            name: item.name,
            showSource: true,
            showSearch: false,
          };
        }) || [],
      };
    });
    this.config.pageModuleConfig = moduleConfig;

    if (this.pageType === 'list') {
      this.config.listPageConfig = {
        headerBtns: ['add-btns'],
        selectType: 'none',
        rowBtns: ['edit-btns', 'view-btns'],
      };
    }
  }
}

